import React, { Fragment } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import {
  Box,
  Grid,
  Card,
  CardContent,
  colors,
  Icon,
  Typography,
  Button,
  makeStyles
} from '@material-ui/core';

import { FaWaveSquare } from "react-icons/fa";
import { MdRouter } from "react-icons/md";
import { BsSpeedometer2 } from "react-icons/bs";
import { FaHandshake } from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";
import { RiEqualizerLine } from "react-icons/ri";
import { MdMemory } from "react-icons/md";
import { RiFileCloudLine } from "react-icons/ri";

const items = [
  {
    href: '/cfg/operations',
    icon: FaHandshake,
    title: 'Contrato',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/devices',
    icon: MdRouter,
    title: 'Dispositivo',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/hardwares',
    icon: MdMemory,
    title: 'Hardware',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/messages',
    icon: FaWaveSquare,
    title: 'Protocolo',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/panels',
    icon: BsSpeedometer2,
    title: 'Instrumentação',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/settings',
    icon: RiEqualizerLine,
    title: 'Parâmetros',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/cfg/storage',
    icon: RiFileCloudLine,
    title: 'Armazenamento',
    color: colors.indigo[400],
    profile: 'ENG'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ENG'
  },
];

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    width: 120,
    height: 120
  },
  grid: {
    marginTop: 10
  },
  card: {
    height: 200,
    minWidth: 200
  },
  button: {
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: 'none',
    width: '100%'
  }
}));

const Results = ({ className }) => {

  const classes = useStyles();

  return (
    <Fragment>
      <Box>
        <Grid container
          className={classes.grid}
          spacing={2}
          direction="row"
          justifyContent={(screen.width <= 480) ? "center" : "flex-start"}
        >

          {items.map((value) => (

            <Grid item key={value.href} hidden={localStorage.getItem('profile') != value.profile}  >

              <Button
                className={classes.button}
                component={RouterLink}
                to={value.href}
              >

                <Card className={classes.card}>

                  <CardContent>

                    <Box alignItems="center"
                      display="flex"
                      flexDirection="column"
                    >

                      {<Icon className={classes.avatar} component={value.icon} style={{ color: value.color }} ></Icon>}

                      <Typography align="center"
                        color="primary"
                        gutterBottom
                        variant="h4"
                      >
                        {value.title}
                      </Typography>
                    </Box>

                  </CardContent>

                </Card>

              </Button>

            </Grid>

          ))}


        </Grid>

      </Box>

    </Fragment >
  );
};

export default Results;